import React from "react";
import MainLayout from "../../layout/MainLayout";
import { Button1, Button2, ProgressBar, Select, Tag } from "../index";
import Meter from "../meter/Meter";
import sortIcon from "../../assets/icons/sort-icon.png";
import bullseyeIcon from "../../assets/icons/bullseye-icon.png";
import winterIcon from "../../assets/icons/winter-Icon.png";
import infoIcon from "../../assets/icons/inforound-icon.png";
import { CiCalendar } from "react-icons/ci";
import { DatePicker, Input } from "antd";
import calendarIcon from "../../assets/icons/calendar-icon.png";
import uploadIcon from "../../assets/icons/upload-icon.png";
import QuickActionSelect from "../quick-action-select/QuickActionSelect";

const SaveAndInvest = () => {
  const inforCards = [
    {
      cardName: "Your on-time payments",
      remark: "EXCELLENT",
      progress: "100%",
      text: "Stay on track of your payments with bill reminders so we can notify you of upcoming payments.",
    },
    {
      cardName: "Your credit usage",
      remark: "EXCELLENT",
      progress: "0%",
      text: "Keep up the good works using your blablablabla so that make the creditors happy.",
    },
  ];

  const myGoalCard = [
    {
      cardName: "Emergency Fund",
      date: "August 21, 2022",
      icon: infoIcon,
      progress: 55,
      otherDetails: [
        {
          name: "Saved",
          amount: "$2.164",
        },
        {
          name: "Target",
          amount: "$2.164",
        },
        {
          name: "Remaining",
          amount: "$2.164",
        },
      ],
    },
    {
      cardName: "Winter Vacation",
      date: "August 21, 2022",
      icon: winterIcon,
      progress: 40,
      otherDetails: [
        {
          name: "Saved",
          amount: "$2.164",
        },
        {
          name: "Target",
          amount: "$2.164",
        },
        {
          name: "Remaining",
          amount: "$2.164",
        },
      ],
    },
  ];

  return (
    <>
      <MainLayout NavName="Save and Invest" expand={false}>
        <div>
          <div className="container mt-5">
            <div className="row ">
              <div className="d-flex justify-content-between align-items-center mt-3">
                <span className="fs-5 fw-semibold">Save and Invest</span>
                <QuickActionSelect />
              </div>

              <div className="d-flex flex-column gap-4 border rounded-3 p-3 px-4 mt-3">
                <div className="d-flex justify-content-between align-items-center ">
                  <span className="fs-5 fw-medium  ps-3">My Risk Profile</span>
                  <span
                    className="fs14px fw-semibold cursor-pointer"
                    style={{ color: "#1bbb6b" }}
                  >
                    Retake Assessment
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center ">
                  <div className="d-flex flex-column ">
                    <Meter meterWidth={"180px"} arcWidth={0.15} />
                    <span
                      className="fs-5 fw-semibold align-self-center"
                      style={{ color: "#0E2C24" }}
                    >
                      685
                    </span>
                  </div>

                  <div
                    className="d-flex flex-column gap-1 rounded-2 p-2 px-3 
                    "
                    style={{
                      color: "#F7A64F",
                      backgroundColor: "#FEF5EB",
                      width: "70%",
                    }}
                  >
                    <span className="fw-semibold fs14px">Medium</span>
                    <span className="fs14px pe-4">
                      This means that you will be less comfortable, but not
                      overly concerned by short terms variations in investment
                      returns, including negative returns when they occur
                    </span>
                  </div>
                </div>
              </div>

              {inforCards.map(({ cardName, remark, text, progress }, key) => (
                <div
                  key={key}
                  className={`col-lg-6  mt-3 ${
                    key % 2 === 0 ? "ps-md-0" : "pe-md-0"
                  }`}
                >
                  <div className="d-flex flex-column gap-3 border rounded-3">
                    <div className="d-flex justify-content-between align-items-center  border-bottom p-3 px-4">
                      <div className="d-flex flex-column gap-1">
                        <span className="fs-5 fw-medium">{cardName}</span>
                        <span
                          className="fs14px fw-semibold"
                          style={{ color: "#1bbb6b" }}
                        >
                          {remark}
                        </span>
                      </div>

                      <span className="fs-4 fw-semibold">{progress}</span>
                    </div>

                    <div
                      className="p-3
                  px-4"
                    >
                      <span className="fs14px " style={{ color: "#7d7d7d" }}>
                        {text}
                      </span>
                    </div>

                    <div className="p-3 px-4">
                      <span
                        className="fs14px fw-semibold cursor-pointer"
                        style={{ color: "#1bbb6b" }}
                      >
                        View Details
                      </span>
                    </div>
                  </div>
                </div>
              ))}

              <div className="d-flex justify-content-between align-items-center mt-4">
                <span className="fs-5 fw-semibold">My Goals</span>
                <Button2
                  buttonName={"Sort"}
                  className={"border"}
                  divClassName={"gap-2"}
                  icon={<img src={sortIcon} alt="sort" />}
                />
              </div>

              <div className="d-flex gap-5 align-items-center mt-3 border rounded-3 p-3 px-4">
                <img src={bullseyeIcon} alt="icon" />

                <Tag
                  tagName={
                    "Set up a new saving goal and see what you need to put aside, what you’ll earn and how long it takes to reach your goal"
                  }
                  className={"w-100  rounded-2"}
                  tagStyle={{ fontSize: "10px", backgroundColor: "#F9F9F9" }}
                />
              </div>

              {myGoalCard.map(
                ({ cardName, progress, icon, otherDetails, date }, key) => (
                  <div
                    key={key}
                    className={`col-lg-6  mt-3 ${
                      key % 2 === 0 ? "ps-md-0" : "pe-md-0"
                    }`}
                  >
                    <div className="d-flex flex-column gap-4 border rounded-3 p-3 px-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex gap-2 align-items-center">
                          <img src={icon} alt="info" />
                          <span className="fs-5 fw-semibold">{cardName}</span>
                        </div>
                        <span
                          className="fw-semibold cursor-pointer"
                          style={{ color: "#1bbb6b" }}
                        >
                          View tracking
                        </span>
                      </div>

                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="fs-6 fw-semibold">{cardName}</label>
                          <div className="d-flex gap-1 align-items-center">
                            <CiCalendar color="#7D7D7D" />
                            <span
                              className="fs13px"
                              style={{ color: "#7D7D7D" }}
                            >
                              {date}
                            </span>
                          </div>
                        </div>
                        <ProgressBar percent={progress} />
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ width: "90%" }}
                        >
                          {otherDetails.map(({ name, amount }, key) => (
                            <span key={key} className="fs12px ">
                              {name}: {"  "}
                              <span
                                className="fw-semibold"
                                style={{ color: "#1bbb6b" }}
                              >
                                {amount}
                              </span>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}

              <div className="d-flex flex-column gap-3 border rounded-3 mt-3 p-3 px-4">
                <span className="fs-5 fw-medium">Add Goals</span>

                <div className="d-flex flex-column gap-4 ">
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ gap: "6rem" }}
                  >
                    <div className="d-flex flex-column gap-2 w-50">
                      <label className="fs12px">Your Goals</label>
                      <Input
                        placeholder="Enter Your Goal"
                        value={"House Deposit"}
                        className="p-3"
                      />
                    </div>

                    <div className="d-flex flex-column gap-2 w-50">
                      <label className="fs12px">Due Date</label>
                      <DatePicker
                        placeholder="January 26,2022"
                        suffixIcon={<img src={calendarIcon} alt="icon" />}
                        className="p-3"
                      />
                    </div>
                  </div>
                  <div
                    className="d-flex justify-content-between align-items-center "
                    style={{ gap: "6rem" }}
                  >
                    <div className="d-flex gap-3 align-items-center w-50">
                      <div className="d-flex flex-column gap-2 w-100">
                        <label className="fs12px">Target</label>
                        <Input
                          className="p-3"
                          placeholder="Input amount"
                          value={22}
                        />
                      </div>
                      <div className="d-flex flex-column gap-2 w-auto">
                        <label className="fs12px">Currency</label>
                        <Select defaultValue="AUD" className="p-3" />
                      </div>
                    </div>

                    <div className="d-flex flex-column gap-2 w-50">
                      <label className="fs12px">Upload Icon or Picture</label>
                      <Input
                        placeholder="Upload or drag files here"
                        suffix={
                          <img
                            src={uploadIcon}
                            alt="icon"
                            className="cursor-pointer"
                          />
                        }
                        className="p-3"
                      />
                    </div>
                  </div>
                </div>

                <Button1
                  buttonName={"Create"}
                  className={"btn-dark align-self-end mt-3"}
                />
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default SaveAndInvest;
